import React from 'react';
import { Map } from 'immutable';

const toProperCase = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const getOptions = (values, allUpper, required) => {
    let options = [];

    !required && options.push(<option key={''} value=''>Select</option>);

    values && values.forEach(value => {
        options.push(<option key={value} value={value}>{allUpper ? value.toUpperCase() : toProperCase(value)}</option>);
    });

    return options;
}


export const getOptionsFromListofMaps = (list, value, display, useSelect = true) => {
    let options = [];

    useSelect && options.push(<option key={''} value=''>Select</option>);

    list && list.forEach((item, index) => {

        const mapItem = !Map.isMap(item) ? Map(item) : item;

        const id = mapItem.get(value);
        const isJurisdictionDropDown = mapItem.get('name') && mapItem.get('state');
        if (isJurisdictionDropDown) {
            options.push(<option key={index} value={id}>{`${mapItem.get('state')} - ${mapItem.get('name')}`}</option>);
        }
        else {
            options.push(<option key={index} value={id}>{mapItem.get(display)}</option>);
        }
    });

    return options;
}

export const getCourtOptions = (courts) => {
    let options = [];

    options.push(<option key={''} value=''>Select</option>);

    courts && courts.forEach(court => {
        const { courtId, name } = court.toJS();
        options.push(<option key={courtId} value={courtId}>{name}</option>);
    });

    return options;
}

export const parseTelephone = (formattedNumber) => {
    const numbers = formattedNumber.split('-');

    if (numbers && numbers.length === 3)
        return {
            formattedNumber,
            areaCode: numbers[0],
            prefix: numbers[1],
            suffix: numbers[2]
        }
    else {
        return {
            formattedNumber
        }
    }
}

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export const addItemToReferenceList = (value, list, keyEvaluator, objCreator) => {
    if (!list)
        list = [];

    const existing = list.find(x => keyEvaluator(x) === value);
    if (existing)
        existing.isActive = true;
    else {
        const newObj = objCreator(value);
        newObj.isActive = true;
        list.push(newObj);
    }

    return list;
}

export const removeItemFromReferenceList = (value, list, keyEvaluator) => list.forEach(x => x.isActive = keyEvaluator(x) === value ? false : x.isActive);

export const defaultColumnCompartor = (a, b) => {
    if (typeof a === 'string') {
        return a.localeCompare(b);
    } else {
        return (a > b ? 1 : (a < b ? -1 : 0));
    }
};